import Vue from 'vue'
import VueRouter from 'vue-router'
import { canAccessRoute, normalizePermissoesTelas } from '../utils/postLoginNavigation'
import { isSuperadminUser } from '../utils/routingModePerfilFilter'
import { TICKET_SCREEN_NAMES } from '../utils/ticketPermissions'
//import Dashboard from '../views/Dashboard.vue'
import Veiculos from '../views/Veiculos.vue'
import Empresas from '../views/Empresas.vue'
import Feriados from '../components/CRUDFeriados.vue'
import Equipamentos from '../views/Equipamentos.vue'
import Funcionarios from '../views/Funcionarios.vue'
import LinhaAssistenteRedirect from '../components/LinhaAssistenteRedirect.vue'
//import RotasMain from '../components/RotasMain.vue'
import Operacao from '../components/OperacaoMain.vue'
import NotificacoesDia from '../components/Notifications/NotificacoesDia.vue'
import CRUDGuias from '../components/CRUDGuias.vue'
import CRUDQuadros from '../components/CRUDQuadros.vue'
//import RotasMap from '../components/RotasMap.vue'
//import RastreamentoMap from '../components/RastreamentoMap.vue'
import Usuarios from '../components/CRUDUsuarios.vue'
import Login from '../components/LoginPage.vue'
import Teste from '../components/Teste.vue'
//import Rastreamento from '../components/RastreamentoMain.vue'
//import DashboardFinanceiro from '../components/DashboardFinanceiro.vue'
import CRUDEscalas from '../components/CRUDEscalas.vue'
// import CRUDPermissionarios from '../components/CRUDPermissionarios.vue'
// import MapaPermissionario from '../components/MapaPermissionario.vue'
// import RouteNotFoundComponent from '../components/RouteNotFoundComponent.vue'
import RELStatusVeiculos from '../components/RELStatusVeiculos.vue'
import RELPrevistoRealizado from '../components/RELPrevistoRealizado.vue'
import RELTempoDePlaca from '../components/RELTempoDePlaca.vue'
// import RELVeiculosSemGuia from '../components/RELVeiculosSemGuia.vue'
import RELPassageirosViagem from '../components/RELPassageirosViagem.vue'
import RELTempoTrecho from '../components/RELTempoTrecho.vue'
import RELComboio from '../components/RELComboio.vue'
import RELPlotagem from '../components/RELPlotagem.vue'
import RELNotificacoes from '../components/RELNotificacoes.vue'
import DashboardNotificacoes from '../components/DashboardNotificacoes.vue'
import RELManutencao from '../components/RELManutencao.vue'
import Config from '../components/Config.vue'
import Rotinas from '../components/Rotinas.vue'
import Perfis from '../components/Perfis.vue'
import ResumoOperacao from '../components/ResumoOperacao.vue'
import Permissoes from '../components/Permissoes.vue'
import PermissoesAcesso from '../components/PermissoesAcesso.vue'
import QuadroViagens from '../components/QuadroViagens.vue'
import DashboardViagens from '../components/DashboardViagens.vue'
import DashboardPassageiros from '../components/DashboardPassageiros.vue'
import Motivos from '../components/CRUDMotivos.vue'
import RELTempoPlacaServico from '../components/RELTempoPlacaServico.vue'
import RELStatusViagens from '../components/RELStatusViagens.vue'
import RELDiarioBordo from '../components/RELDiarioBordo.vue'
import RELCumprimentoRota from '../components/RELCumprimentoRota.vue'
import MapaMonitor from '../components/MapaMonitor.vue'
//import { component } from 'vue/types/umd.js'
import Roleteiro from '../components/Roleteiro.vue'
import StatusEquipamento from '../components/StatusEquipamento.vue'
import RELGridStatus from '../components/RELGridStatus.vue'
import RELVeiculosCerca from '../components/RELVeiculosCerca.vue'
import VeiculosCercas from '../components/VeiculosCercas.vue'
import RELManutencaoHistorico from '../components/RELManutencaoHistorico.vue';
import RELVeiculosAreaMapa from '../components/RELVeiculosAreaMapa.vue';
import Telemetria from '../components/Telemetria.vue';
import RELVelocidade from '../components/RELVelocidade.vue';
import RELMotoristaVeiculo from '../components/RELMotoristaVeiculo.vue';
import VeiculosGaragem from '../components/VeiculosGaragem.vue';
import CriarTabela from '../components/CriarTabela.vue';
import Painel from '../components/Painel.vue'
import ConsultaPassageiro from '../components/ConsultaPassageiro.vue'
import GuiasMotorista from '../components/GuiasMotorista.vue'
import JornadaMotorista from '../components/JornadaMotorista.vue'
import MotoristaApp from '../components/MotoristaApp.vue'
import PerfilMotorista from '../components/PerfilMotorista.vue'
import CRUDAparencia from '../components/CRUDAparencia.vue'
import RELLancamentosControladores from '../components/RELLancamentosControladores.vue'
import CRUDTrechos from '../components/CRUDTrechos.vue'
import DashboardMain from '../components/DashboardMain.vue'
import CRUDPessoas from '../components/CRUDPessoas.vue'
import CRUDGrupos from '../components/CRUDGrupos.vue'
import CRUDEquipes from '../components/CRUDEquipes.vue'
import HomePassageiro from '../components/HomePassageiro.vue'
import RELEmbarques from '../components/RELEmbarques.vue'
import CRUDMensagens from '../components/CRUDMensagens.vue'
import RELComunicacao from '../components/RELComunicacao.vue'
import CRUDSituacoes from '../components/CRUDSituacoes.vue'
import CRUDCandidatos from '../components/CRUDCandidatos.vue'
import ChecklistVeiculos from '../components/ChecklistVeiculos.vue'
import RecuperarSenha from '../components/RecuperarSenha.vue'
import CRUDTemplates from '../components/CRUDTemplatesMensagens.vue'
import RELAtrasoCercas from '../components/RELAtrasoCercas.vue'
import RELAtrasoViagens from '../components/RELAtrasoViagens.vue'
import RELPontualidade from '../components/RELPontualidade.vue'
import RELKpisEnderecosExternos from '../components/RELKpisEnderecosExternos.vue'
import RELOcupacaoTurno from '../components/RELOcupacaoTurno.vue'
import RELOperacao from '../components/RELOperacao.vue'
import RELPassageirosLinhaDia from '../components/RELPassageirosLinhaDia.vue'
import GoogleChat from '../components/GoogleChat.vue'
import CRUDContratos from '../components/CRUDContratos.vue'
import CRUDContratosSubsidioV2 from '../components/CRUDContratosSubsidioV2.vue'
import CRUDContratoTemplates from '../components/CRUDContratoTemplates.vue'
import CRUDTemplatesRecebidos from '../components/CRUDTemplatesRecebidos.vue'
import CRUDIndicadoresReajuste from '../components/CRUDIndicadoresReajuste.vue'
import RELSubsidio from '../components/RELSubsidio.vue'
import RELVeiculosKm from '../components/RELVeiculosKm.vue'
import CRUDTarifas from '../components/CRUDTarifas.vue'
import SubsidioScorecardMelibrasil from '../components/SubsidioScorecardMelibrasil.vue'
import PoliticaDePrivacidade from '../components/PoliticaDePrivacidade.vue'
import PoliticaDePrivacidadePartiuApp from '../components/PoliticaDePrivacidadePartiuApp.vue'
import ControleSubsidio from '../components/ControleSubsidio.vue'
import TroubleshootingLocalizacao from '../views/TroubleshootingLocalizacao.vue'
import TroubleshootingPWA from '../views/TroubleshootingPWA.vue'
import TicketsPage from '../components/tickets/TicketsPage.vue'
import TicketAssistPage from '../components/tickets/TicketAssistPage.vue'
import CRUDAtendimentoConfig from '../components/tickets/CRUDAtendimentoConfig.vue'
import CRUDCategoriasTickets from '../components/tickets/CRUDCategoriasTickets.vue'
import CRUDAgenciasEmprego from '../components/tickets/CRUDAgenciasEmprego.vue'
import TicketSolicitacaoCandidatos from '../components/tickets/TicketSolicitacaoCandidatos.vue'
import TicketSuporteSistema from '../components/tickets/TicketSuporteSistema.vue'
import RELTicketsPorStatus from '../components/tickets/RELTicketsPorStatus.vue'
import RELTicketsSuporte from '../components/tickets/RELTicketsSuporte.vue'
import Videowall from '../components/Videowall.vue'
import RELKmTempoReal from '../components/RELKmTempoReal.vue'
import DashSinotico from '../components/DashSinotico.vue'
import ConciliacaoViagens from '../components/ConciliacaoViagens.vue'
import RELConciliacao from '../components/RELConciliacao.vue'
import DashboardsBI from '../components/DashboardsBI.vue'
import RELHistoricoVeiculo from '../components/RELHistoricoVeiculo.vue'
import RELHistoricoEquipamento from '../components/checklistEquipamento/RELHistoricoEquipamento.vue'
import RELSubsidioMensal from '../components/RELSubsidioMensal.vue'
import CRUDVigencia from '../components/Vigencia/CRUDVigencia.vue'
import CRUDClientes from '../components/CRUDClientes.vue'
import CRUDTags from '../components/CRUDTags.vue'
import CRUDTurnos from '../components/CRUDTurnos.vue'
import CRUDTurnosPassageiros from '../components/CRUDTurnosPassageiros.vue'
import CRUDTurnosFuncionarios from '../components/CRUDTurnosFuncionarios.vue'
import Plugin from '../components/Plugin.vue'
import RELAcessoQrCode from '../components/RELAcessoQrCode.vue'
import RELHistoricoEnvioQrCode from '../components/RELHistoricoEnvioQrCode.vue'
import RELEnvioAutomaticoQrCode from '../components/RELEnvioAutomaticoQrCode.vue'
import RELHistoricoRoteirizacao from '../components/RELHistoricoRoteirizacao.vue'
import RELHistoricoRotas from '../components/RELHistoricoRotas.vue'
import RELConsumoApiExterna from '../components/RELConsumoApiExterna.vue'
import ReservasCandidatos from '../components/ReservasCandidatos.vue'
import CRUDClassificacoesViagens from '../components/CRUDClassificacoesViagens.vue'
import FechamentoDia from '../components/FechamentoDia.vue'
import Roteirizacao from '../components/Roteirizacao.vue'
import RecursosOperacao from '../components/RecursosOperacao.vue'
import Monitriip from '../components/Monitriip.vue'
import RELUsuariosPassageiros from '../components/RELUsuariosPassageiros.vue'
import CRUDChecklistEquipamento from '../components/checklistEquipamento/CRUDChecklistEquipamento.vue'
import PopularChecklistEquipamento from '../components/checklistEquipamento/PopularChecklistEquipamento.vue'
import RELChecklistsFuncionario from '../components/checklistEquipamento/RELChecklistsFuncionario.vue'
import CRUDKits from '../components/CRUDKits.vue'
import CRUDTiposKits from '../components/CRUDTiposKits.vue'
import CRUDNotasFiscais from '../components/CRUDNotasFiscais.vue'
import ActivateEquipamentoNotaFiscal from '../components/ActivateEquipamentoNotaFiscal.vue'
import CRUDTiposEquipamentos from '../components/CRUDTiposEquipamentos.vue'
import CRUDProdutosInternos from '../components/CRUDProdutosInternos.vue'
import CRUDSimCards from '../components/CRUDSimCards.vue'
import AUDIntegracaoSSFF from '../components/AUDIntegracaoSSFF.vue'
import AUDSystemLog from '../components/AUDSystemLog.vue'
import AUDAuditoriaViagens from '../components/AUDAuditoriaViagens.vue'
import NotasAtualizacao from '../components/NotasAtualizacao.vue'
import RELEventosHikvision from '../components/RELEventosHikvision.vue'
import RELViagensCerca from '../components/RELViagensCerca.vue'
import SolicitacoesRelatorios from '../components/SolicitacoesRelatorios.vue'
import RelatoriosExtenso from '../components/RelatoriosExtenso.vue'
import CRUDViagensPrevistas from '../components/CRUDViagensPrevistas.vue'
import RELEmbarquesTrecho from '../components/RELEmbarquesTrecho.vue'
import DIAGDesviosOperacionais from '../components/DIAGDesviosOperacionais.vue'
import DIAGInconsistenciaDados from '../components/DIAGInconsistenciaDados.vue'
import DIAGAdocaoSistema from '../components/DIAGAdocaoSistema.vue'
import DIAGComparacaoETAs from '../components/DIAGComparacaoETAs.vue'

import { routerMode, consultaPassageiroRequiresAuth } from '../constants'

Vue.use(VueRouter)

const redirectToRecursosOperacao = (modulo) => (to) => ({
  path: '/recursosoperacao',
  query: { ...to.query, modulo },
});

const recursosOperacaoPermissionAnyOf = ['Linhas', 'Rotas', 'Cercas', 'Unidades', 'Areas'];

/** Histórico de rotas: a tela legada de alterações de rotas ainda dá acesso (só à aba Alterações). */
const historicoRotasPermissionAnyOf = ['RELHistoricoRotas', 'RELHistoricoAlteracoesRotas'];

/** Telas antigas de tickets/painéis: agora são visões da tela única /tickets. */
const redirectToTickets = (visao) => (to) => ({
  path: '/tickets',
  query: { ...to.query, visao },
});

const routes = [
    { path: '/viagensprevistas', name: 'ViagensPrevistas', component: CRUDViagensPrevistas, meta: { requiresAuth: true } },
  { path: '/', name: 'Login', component: Login },
  { path: '/plugin', name: 'Plugin', component: Plugin, meta: { requiresAuth: false } },
  //{ path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/veiculos', name: 'Veiculos', component: Veiculos, meta: { requiresAuth: true } },
  { path: '/pessoas', name: 'Pessoas', component: CRUDPessoas, meta: { requiresAuth: true } },
  { path: '/grupos', name: 'Grupos', component: CRUDGrupos, meta: { requiresAuth: true } },
  { path: '/equipes', name: 'Equipes', component: CRUDEquipes, meta: { requiresAuth: true } },
  { path: '/passageiro', name: 'Passageiro', component: HomePassageiro, meta: { requiresAuth: true } },
  { path: '/dashboard', name: 'Dashboard', component: DashboardMain, meta: { requiresAuth: true } },
  //{ path: '/rastreamento', name: 'Rastreamento', component: Rastreamento },
  { path: '/empresas', name: 'Empresas', component: Empresas },
  { path: '/equipamentos', name: 'Equipamentos', component: Equipamentos, meta: { requiresAuth: true } },
  { path: '/tiposequipamentos', name: 'TiposEquipamentos', component: CRUDTiposEquipamentos, meta: { requiresAuth: true } },
  { path: '/produtosinternos', name: 'ProdutosInternos', component: CRUDProdutosInternos, meta: { requiresAuth: true } },
  { path: '/simcards', name: 'SimCards', component: CRUDSimCards, meta: { requiresAuth: true } },
  { path: '/feriados', name: 'Feriados', component: Feriados, meta: { requiresAuth: true } },
  { path: '/unidades', name: 'Unidades', redirect: redirectToRecursosOperacao('unidades'), meta: { requiresAuth: true } },
  { path: '/funcionarios', name: 'Funcionarios', component: Funcionarios, meta: { requiresAuth: true } },
  { path: '/linhas', name: 'Linhas', redirect: redirectToRecursosOperacao('linhas'), meta: { requiresAuth: true } },
  { path: '/linhas/assistente', name: 'LinhasAssistente', component: LinhaAssistenteRedirect, meta: { requiresAuth: true, permissionScreen: 'Linhas' } },
  { path: '/operacao', name: 'Operacao', component: Operacao, meta: { requiresAuth: true } },
  { path: '/notificacoesdia', name: 'NotificacoesDia', component: NotificacoesDia, meta: { requiresAuth: true } },
  { path: '/guias', name: 'Guias', component: CRUDGuias, meta: { requiresAuth: true } },
  { path: '/quadros', name: 'Quadros', component: CRUDQuadros, meta: { requiresAuth: true } },
  // { path: '/permissionarios', name: 'Permissionarios', component: CRUDPermissionarios },
  { path: '/rotas', name: 'Rotas', redirect: redirectToRecursosOperacao('rotas'), meta: { requiresAuth: true } },
  //{ path: '/rotasmap/:IdRota/:isRotaAtiva', name: 'RotasMap', component: RotasMap, props: true, },
  //{ path: '/rastreamentomap/:pVeiculo/:pFullTitle', name: 'RastreamentoMap', component: RastreamentoMap, props: true, },
  { path: '/usuarios', name: 'Usuarios', component: Usuarios, meta: { requiresAuth: true } },
  { path: '/cercas', name: 'Cercas', redirect: redirectToRecursosOperacao('cercas'), meta: { requiresAuth: true } },
  { path: '/teste', name: 'Teste', component: Teste, meta: { requiresAuth: true, permissionScreen: 'Cercas' } },
  { path: '/areas', name: 'Areas', redirect: redirectToRecursosOperacao('areas'), meta: { requiresAuth: true } },
  { path: '/escalas', name: 'Escalas', component: CRUDEscalas, meta: { requiresAuth: true } },
  { path: '/relstatusveiculos', name: 'RELStatusVeiculos', component: RELStatusVeiculos, meta: { requiresAuth: true } },
  { path: '/relprevistorealizado', name: 'RELPrevistoRealizado', component: RELPrevistoRealizado, meta: { requiresAuth: true } },
  { path: '/reltempodeplaca', name: 'RELTempoDePlaca', component: RELTempoDePlaca, meta: { requiresAuth: true } },
  { path: '/reltempodeplacaservico', name: 'RELTempoPlacaServico', component: RELTempoPlacaServico, meta: { requiresAuth: true } },
  // { path: '/relveiculossemguia', name: 'RELVeiculosSemGuia', component: RELVeiculosSemGuia, meta: { requiresAuth: true }  },
  { path: '/relpassageirosviagem', name: 'RELPassageirosViagem', component: RELPassageirosViagem, meta: { requiresAuth: true } },
  { path: '/reltempotrecho', name: 'RELTempoTrecho', component: RELTempoTrecho, meta: { requiresAuth: true } },
  { path: '/relcomboio', name: 'RELComboio', component: RELComboio, meta: { requiresAuth: true } },
  { path: '/relplotagem', name: 'RELPlotagem', component: RELPlotagem, meta: { requiresAuth: true } },
  { path: '/relnotificacoes', name: 'RELNotificacoes', component: RELNotificacoes, meta: { requiresAuth: true } },
  { path: '/dashboardnotificacoes', name: 'DashboardNotificacoes', component: DashboardNotificacoes, meta: { requiresAuth: true } },
  { path: '/relmanutencao', name: 'RELManutencao', component: RELManutencao, meta: { requiresAuth: true } },
  { path: '/relstatusviagens', name: 'RELStatusViagens', component: RELStatusViagens, meta: { requiresAuth: true } },
  { path: '/reldiariobordo', name: 'RELDiarioBordo', component: RELDiarioBordo, meta: { requiresAuth: true } },
  { path: '/relcumprimentorota', name: 'RELCumprimentoRota', component: RELCumprimentoRota, meta: { requiresAuth: true } },
  // { path: '/mapapermissionario', name: 'Permissionario', component: MapaPermissionario },
  { path: '/notas-fiscais', name: 'NotasFiscais', component: CRUDNotasFiscais, meta: { requiresAuth: true } },
  { path: '/ativar-equipamento-nota-fiscal', name: 'ActivateEquipamentoNotaFiscal', component: ActivateEquipamentoNotaFiscal, meta: { requiresAuth: true } },
  //{ path: '/dashboardfinanceiro', name: 'DashboardFinanceiro', component: DashboardFinanceiro },
  { path: '/config', name: 'Config', component: Config, meta: { requiresAuth: true } },
  { path: '/rotinas', name: 'Rotinas', component: Rotinas, meta: { requiresAuth: true } },
  { path: '/perfis', name: 'Perfis', component: Perfis, meta: { requiresAuth: true } },
  { path: '/resumo', name: 'ResumoOperacao', component: ResumoOperacao, meta: { requiresAuth: true } },
  { path: '/permissoes', name: 'Permissoes', component: Permissoes, meta: { requiresAuth: true } },
  { path: '/permissoes-acesso', name: 'PermissoesAcesso', component: PermissoesAcesso, meta: { requiresAuth: true, permissionScreen: 'PermissoesAcesso' } },
  { path: '/quadroviagens', name: 'QuadroViagens', component: QuadroViagens, meta: { requiresAuth: true } },
  { path: '/dashboardviagens', name: 'DashboardViagens', component: DashboardViagens, meta: { requiresAuth: true } },
  { path: '/dashboardpassageiros', name: 'DashboardPassageiros', component: DashboardPassageiros, meta: { requiresAuth: true } },
  { path: '/motivos', name: 'Motivos', component: Motivos, meta: { requiresAuth: true } },
  { path: '/mapamonitor', name: 'MapaMonitor', component: MapaMonitor, meta: { requiresAuth: true } },
  { path: '/roleteiro', name: 'Roleteiro', component: Roleteiro, meta: { requiresAuth: false } },
  { path: '/aparencia', name: 'Aparencia', component: CRUDAparencia, meta: { requiresAuth: true } },
  { path: '/statusequipamento/:cod?', name: 'StatusEquipamento', component: StatusEquipamento, meta: { requiresAuth: true } },
  { path: '/relgridstatus', name: 'RELGridStatus', component: RELGridStatus, meta: { requiresAuth: true } },
  { path: '/relveiculoscerca', name: 'RELVeiculosCerca', component: RELVeiculosCerca, meta: { requiresAuth: true } },
  { path: '/veiculoscercas', name: 'VeiculosCercas', component: VeiculosCercas, meta: { requiresAuth: true } },
  { path: '/relmanutencaohistorico', name: 'RELManutencaoHistorico', component: RELManutencaoHistorico, meta: { requiresAuth: true } },
  { path: '/relveiculosareamapa', name: 'RELVeiculosAreaMapa', component: RELVeiculosAreaMapa, meta: { requiresAuth: true } },
  { path: '/telemetria', name: 'Telemetria', component: Telemetria, meta: { requiresAuth: true } },
  { path: '/relvelocidade', name: 'RELVelocidade', component: RELVelocidade, meta: { requiresAuth: true } },
  { path: '/relmotoristaveiculo', name: 'RELMotoristaVeiculo', component: RELMotoristaVeiculo, meta: { requiresAuth: true } },
  { path: '/veiculosgaragem', name: 'VeiculosGaragem', component: VeiculosGaragem, meta: { requiresAuth: false } },
  { path: '/criartabela', name: 'CriarTabela', component: CriarTabela, meta: { requiresAuth: true } },
  { path: '/painel/:raio?', name: 'Painel', component: Painel, meta: { requiresAuth: false } },
  { path: '/consultapassageiro', name: 'ConsultaPassageiro', component: ConsultaPassageiro, meta: { authBySetupModo: true } },
  {
    path: '/guiasmotorista',
    component: MotoristaApp,
    meta: { requiresAuth: true, permissionScreen: 'GuiasMotorista' },
    redirect: { name: 'JornadaMotorista' },
    children: [
      { path: '', name: 'JornadaMotorista', component: JornadaMotorista, meta: { requiresAuth: true, permissionScreen: 'GuiasMotorista' } },
      { path: 'guias', name: 'GuiasMotorista', component: GuiasMotorista, meta: { requiresAuth: true, permissionScreen: 'GuiasMotorista' } },
    ],
  },
  { path: '/motoristaperfil', name: 'PerfilMotorista', component: PerfilMotorista, meta: { requiresAuth: true } },
  // Status dos Dispositivos, Hikvision e Firmwares ISAPI foram absorvidas pela tela de Equipamentos.
  { path: '/statusdispositivos', redirect: '/equipamentos' },
  { path: '/hikvisionacesso', redirect: '/equipamentos' },
  { path: '/isapifirmwares', redirect: '/equipamentos' },
  { path: '/relcontroladores', name: 'RELLancamentosControladores', component: RELLancamentosControladores, meta: { requiresAuth: true } },
  { path: '/releventoshikvision', name: 'RELEventosHikvision', component: RELEventosHikvision, meta: { requiresAuth: true } },
  { path: '/trechos', name: 'Trechos', component: CRUDTrechos, meta: { requiresAuth: true } },
  { path: '/mensagens', name: 'Mensagens', component: CRUDMensagens, meta: { requiresAuth: true } },
  { path: '/templates', name: 'Templates', component: CRUDTemplates, meta: { requiresAuth: true } },
  { path: '/situacoes', name: 'Situacoes', component: CRUDSituacoes, meta: { requiresAuth: true } },
  { path: '/candidatos', name: 'Candidatos', component: CRUDCandidatos, meta: { requiresAuth: true } },
  { path: '/relcomunicacao', name: 'RELComunicacao', component: RELComunicacao, meta: { requiresAuth: true } },
  { path: '/inspecaoveiculo', name: 'ChecklistVeiculos', component: ChecklistVeiculos, meta: { requiresAuth: true } },
  { path: '/recupera', name: 'RecuperarSenha', component: RecuperarSenha, meta: { requiresAuth: false } },
  { path: '/relatrasocercas', name: 'RELAtrasoCercas', component: RELAtrasoCercas, meta: { requiresAuth: true } },
  { path: '/relatrasoviagens', name: 'RELAtrasoViagens', component: RELAtrasoViagens, meta: { requiresAuth: true } },
  { path: '/relpontualidade', name: 'RELPontualidade', component: RELPontualidade, meta: { requiresAuth: true } },
  { path: '/relkpisenderecosexternos', name: 'RELKpisEnderecosExternos', component: RELKpisEnderecosExternos, meta: { requiresAuth: true } },
  { path: '/relocupacaoporturno', name: 'RELOcupacaoTurno', component: RELOcupacaoTurno, meta: { requiresAuth: true } },
  { path: '/reloperacao', name: 'RELOperacao', component: RELOperacao, meta: { requiresAuth: true } },
  { path: '/relpassageiroslinhadia', name: 'RELPassageirosLinhaDia', component: RELPassageirosLinhaDia, meta: { requiresAuth: true } },
  { path: '/googlechat', name: 'GoogleChat', component: GoogleChat, meta: { requiresAuth: false } },
  { path: '/contratos', name: 'Contratos', component: CRUDContratos, meta: { requiresAuth: true } },
  // Tela nova de contratos: valores por tipo de veículo. Convive com /contratos,
  // que segue atendendo os contratos de CONTROLE.
  { path: '/contratos-subsidio', name: 'ContratosSubsidioV2', component: CRUDContratosSubsidioV2, meta: { requiresAuth: true, permissionScreen: 'ContratosSubsidioV2' } },
  { path: '/contrato-templates', name: 'ContratoTemplates', component: CRUDContratoTemplates, meta: { requiresAuth: true, permissionScreen: 'ContratoTemplates' } },
  { path: '/templates-recebidos', name: 'TemplatesRecebidos', component: CRUDTemplatesRecebidos, meta: { requiresAuth: true, permissionScreen: 'TemplatesRecebidos' } },
  { path: '/indicadores-reajuste', name: 'IndicadoresReajuste', component: CRUDIndicadoresReajuste, meta: { requiresAuth: true, permissionScreen: 'IndicadoresReajuste' } },
  // Lazy: isola dagre e vue-styled-components num chunk próprio, fora do bundle principal.
  { path: '/subsidio-motor-catalogo', name: 'SubsidioMotorCatalogo', component: () => import('../components/SubsidioMotorCatalogo.vue'), meta: { requiresAuth: true, permissionScreen: 'SubsidioMotorCatalogo' } },
  { path: '/subsidio-scorecard-melibrasil', name: 'SubsidioScorecardMelibrasil', component: SubsidioScorecardMelibrasil, meta: { requiresAuth: true, permissionScreen: 'SubsidioScorecardMelibrasil' } },
  { path: '/relsubsidio', name: 'RELSubsidio', component: RELSubsidio, meta: { requiresAuth: true } },
  { path: '/relveiculoskm', name: 'RELVeiculosKm', component: RELVeiculosKm, meta: { requiresAuth: true } },
  { path: '/tarifas', name: 'Tarifas', component: CRUDTarifas, meta: { requiresAuth: true } },
  { path: '/politicadeprivacidade', name: 'Privacidade', component: PoliticaDePrivacidade, meta: { requiresAuth: false } },
  { path: '/politicadeprivacidadepartiuapp', name: 'PrivacidadePartiuApp', component: PoliticaDePrivacidadePartiuApp, meta: { requiresAuth: false } },
  { path: '/controlesubsidio', name: 'ControleSubsidio', component: ControleSubsidio, meta: { requiresAuth: true } },
  { path: '/troubleshooting-localizacao', name: 'TroubleshootingLocalizacao', component: TroubleshootingLocalizacao, meta: { requiresAuth: false } },
  { path: '/tickets', name: 'Tickets', component: TicketsPage, meta: { requiresAuth: true, permissionAnyOf: TICKET_SCREEN_NAMES } },
  { path: '/tickets-colaborador', name: 'TicketsColaborador', redirect: redirectToTickets('atribuidos'), meta: { requiresAuth: true } },
  { path: '/tickets-dispatcher', name: 'TicketsDispatcher', redirect: redirectToTickets('equipe'), meta: { requiresAuth: true } },
  { path: '/tickets-supervisor', name: 'TicketsSupervisor', redirect: redirectToTickets('todos'), meta: { requiresAuth: true } },
  { path: '/tickets-criados', name: 'TicketsCriados', redirect: redirectToTickets('criados'), meta: { requiresAuth: true } },
  { path: '/tickets-cliente', name: 'TicketsCliente', redirect: redirectToTickets('criados'), meta: { requiresAuth: true } },
  { path: '/agencias-emprego', name: 'AgenciasEmprego', component: CRUDAgenciasEmprego, meta: { requiresAuth: true } },
  { path: '/tickets-solicitacao-candidatos', name: 'TicketsSolicitacaoCandidatos', component: TicketSolicitacaoCandidatos, meta: { requiresAuth: true } },
  { path: '/tickets-suporte-sistema', name: 'TicketsSuporteSistema', component: TicketSuporteSistema, meta: { requiresAuth: true } },
  { path: '/ticket-assist', name: 'TicketAssist', component: TicketAssistPage, meta: { requiresAuth: true } },
  { path: '/atendimentoconfig', name: 'AtendimentoConfig', component: CRUDAtendimentoConfig, meta: { requiresAuth: true } },
  { path: '/tickets-team', name: 'TicketsTeam', redirect: redirectToTickets('equipe'), meta: { requiresAuth: true } },
  { path: '/categoriatickets', name: 'CategoriasTickets', component: CRUDCategoriasTickets, meta: { requiresAuth: true } },
  {
    path: '/statustickets',
    name: 'StatusTickets',
    redirect: { path: '/config', query: { section: 'ticket_status' } },
    meta: { requiresAuth: true },
  },
  {
    path: '/relticketsstatusagendamento',
    redirect: (to) => ({ path: '/relticketsporstatus', query: { ...to.query, view: 'agendamento' } }),
  },
  { path: '/relticketsporstatus', name: 'RELTicketsPorStatus', component: RELTicketsPorStatus, meta: { requiresAuth: true } },
  { path: '/relticketssuporte', name: 'RELTicketsSuporte', component: RELTicketsSuporte, meta: { requiresAuth: true } },
  { path: '/videowall', name: 'Videowall', component: Videowall, meta: { requiresAuth: true } },
  { path: '/relkmtemporeal', name: 'RELKmTempoReal', component: RELKmTempoReal, meta: { requiresAuth: true } },
  { path: '/dashsinotico', name: 'DashSinotico', component: DashSinotico, meta: { requiresAuth: false } },
  { path: '/conciliacaoviagens', name: 'ConciliacaoViagens', component: ConciliacaoViagens, meta: { requiresAuth: true } },
  { path: '/relconciliacao', name: 'RELConciliacao', component: RELConciliacao, meta: { requiresAuth: true } },
  { path: '/troubleshooting-pwa', name: 'TroubleshootingPWA', component: TroubleshootingPWA, meta: { requiresAuth: false } },
  { path: '/dashboards', name: 'Dashboards', component: DashboardsBI, meta: { requiresAuth: true } },
  { path: '/relhistoricoveiculo', name: 'RELHistoricoVeiculo', component: RELHistoricoVeiculo, meta: { requiresAuth: true } },
  { path: '/subsidiomensal', name: 'RELSubsidioMensal', component: RELSubsidioMensal, meta: { requiresAuth: true } },
  { path: '/vigencia', name: 'Vigencia', component: CRUDVigencia, meta: { requiresAuth: true } },
  { path: '/clientes', name: 'Clientes', component: CRUDClientes, meta: { requiresAuth: true } },
  { path: '/tags', name: 'Tags', component: CRUDTags, meta: { requiresAuth: true } },
  { path: '/turnos', name: 'Turnos', component: CRUDTurnos, meta: { requiresAuth: true } },
  { path: '/turnospassageiros', name: 'TurnosPassageiros', component: CRUDTurnosPassageiros, meta: { requiresAuth: true } },
  { path: '/turnosfuncionarios', name: 'TurnosFuncionarios', component: CRUDTurnosFuncionarios, meta: { requiresAuth: true } },
  { path: '/relacessoqrcode', name: 'RELAcessoQrCode', component: RELAcessoQrCode, meta: { requiresAuth: true } },
  { path: '/relconsumoapi', name: 'RELConsumoApiExterna', component: RELConsumoApiExterna, meta: { requiresAuth: true } },
  { path: '/relhistoricoenvioqrcode', name: 'RELHistoricoEnvioQrCode', component: RELHistoricoEnvioQrCode, meta: { requiresAuth: true } },
  { path: '/relenvioautomaticoqrcode', name: 'RELEnvioAutomaticoQrCode', component: RELEnvioAutomaticoQrCode, meta: { requiresAuth: true } },
  { path: '/relhistoricoalteracoesrotas', redirect: (to) => ({ path: '/relhistoricorotas', query: { ...to.query, tipo: 'alteracoes' } }) },
  { path: '/relhistoricoroteirizacao', name: 'RELHistoricoRoteirizacao', component: RELHistoricoRoteirizacao, meta: { requiresAuth: true } },
  { path: '/relhistoricorotas', name: 'RELHistoricoRotas', component: RELHistoricoRotas, meta: { requiresAuth: true, permissionAnyOf: historicoRotasPermissionAnyOf } },
  { path: '/relhistoricorotasotimizadas', redirect: (to) => ({ path: '/relhistoricorotas', query: to.query }) },
  { path: '/reservas-candidatos', name: 'RELReservasCandidatos', component: ReservasCandidatos, meta: { requiresAuth: true, permissionScreen: 'RELReservasCandidatos' } },
  { path: '/classificacoesviagens', name: 'ClassificacoesViagens', component: CRUDClassificacoesViagens, meta: { requiresAuth: true } },
  { path: '/fechamentodia', name: 'FechamentoDia', component: FechamentoDia, meta: { requiresAuth: true } },
  { path: '/roteirizacao', name: 'Roteirizacao', component: Roteirizacao, meta: { requiresAuth: true, permissionScreen: 'Roteirizacao' } },
  { path: '/recursosoperacao', name: 'RecursosOperacao', component: RecursosOperacao, meta: { requiresAuth: true, permissionAnyOf: recursosOperacaoPermissionAnyOf } },
  { path: '/monitriip', name: 'Monitriip', component: Monitriip, meta: { requiresAuth: true } },
  { path: '/relusuariospassageiros', name: 'RELUsuariosPassageiros', component: RELUsuariosPassageiros, meta: { requiresAuth: true } },
  { path: '/cadastrochecklistequipamento', name: 'CadastroChecklistEquipamento', component: CRUDChecklistEquipamento, meta: { requiresAuth: true } },
  { path: '/popularchecklistequipamento', name: 'PopularChecklistEquipamento', component: PopularChecklistEquipamento, meta: { requiresAuth: true } },
  { path: '/relchecklistsequipamentosfuncionario', name: 'RELChecklistsFuncionario', component: RELChecklistsFuncionario, meta: { requiresAuth: true } },
  { path: '/relhistoricoequipamento', name: 'RELHistoricoEquipamento', component: RELHistoricoEquipamento, meta: { requiresAuth: true } },
  { path: '/kits', name: 'Kits', component: CRUDKits, meta: { requiresAuth: true } },
  { path: '/tiposkits', name: 'TiposKits', component: CRUDTiposKits, meta: { requiresAuth: true } },
  { path: '/audit/integracaossff', name: 'AUDIntegracaoSSFF', component: AUDIntegracaoSSFF, meta: { requiresAuth: true } },
  { path: '/audit/systemlog', name: 'AUDSystemLog', component: AUDSystemLog, meta: { requiresAuth: true } },
  { path: '/audit/auditoriaviagens', name: 'AUDAuditoriaViagens', component: AUDAuditoriaViagens, meta: { requiresAuth: true } },
  { path: '/notas-atualizacao', name: 'NotasAtualizacao', component: NotasAtualizacao, meta: { requiresAuth: true } },
  { path: '/relembarques', name: 'RELEmbarques', component: RELEmbarques, meta: { requiresAuth: true } },
  { path: '/relviagenscerca', name: 'RELViagensCerca', component: RELViagensCerca, meta: { requiresAuth: true } },
  { path: '/solicitacoesrelatorios', name: 'SolicitacoesRelatorios', component: SolicitacoesRelatorios, meta: { requiresAuth: true } },
  { path: '/relatoriosextenso', name: 'RelatoriosExtenso', component: RelatoriosExtenso, meta: { requiresAuth: true } },
  { path: '/relembarquestrecho', name: 'RELEmbarquesTrecho', component: RELEmbarquesTrecho, meta: { requiresAuth: true } },
  { path: '/diagnosticos/desviosoperacionais', name: 'DIAGDesviosOperacionais', component: DIAGDesviosOperacionais, meta: { requiresAuth: true } },
  { path: '/diagnosticos/inconsistenciadados', name: 'DIAGInconsistenciaDados', component: DIAGInconsistenciaDados, meta: { requiresAuth: true } },
  { path: '/diagnosticos/adocaosistema', name: 'DIAGAdocaoSistema', component: DIAGAdocaoSistema, meta: { requiresAuth: true } },
  { path: '/diagnosticos/comparacaoetas', name: 'DIAGComparacaoETAs', component: DIAGComparacaoETAs, meta: { requiresAuth: true } },
  { path: '/reldesviosoperacionais', redirect: '/diagnosticos/desviosoperacionais' },
  { path: '/relcomparacaoetas', redirect: '/diagnosticos/comparacaoetas' },
  { path: '*', name: 'RouteNotFound', redirect: '/' },
]

const checkLogin = function (route) {
  let user = null;
  let permissoes = null;
  try {
    user = JSON.parse(sessionStorage.getItem("user"));
    permissoes = JSON.parse(sessionStorage.getItem("permissoes") || "[]");
  } catch (e) {
    return false;
  }
  const token = sessionStorage.getItem("api");

  if (user == null || token == null) {
    return false;
  }
  if (isSuperadminUser(user)) {
    return true;
  }
  if (!Array.isArray(permissoes)) {
    return false;
  }
  return canAccessRoute(user, normalizePermissoesTelas(permissoes), route);
};

const isBenignNavigationError = function (err) {
  return err && (
    err.name === 'NavigationDuplicated' ||
    err.name === 'NavigationRedirected' ||
    err.name === 'NavigationCancelled'
  );
};

const router = new VueRouter({
  mode: routerMode,
  routes: routes
});

// Evita rejeição não tratada em redirecionamentos e rotas duplicadas (Vue Router 3)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (!isBenignNavigationError(err)) throw err;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => {
    if (!isBenignNavigationError(err)) throw err;
  });
};

router.beforeEach((to, from, next) => {
  const hashRoute =
    routerMode === "history" &&
    to.path === "/" &&
    window.location.hash &&
    window.location.hash.startsWith("#/");
  if (hashRoute) {
    next(window.location.hash.slice(1));
    return;
  }

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (to.matched.some(record => record.meta.authBySetupModo)) {
    requiresAuth = consultaPassageiroRequiresAuth();
  }

  if (!requiresAuth) {
    next();
    return;
  }

  if (checkLogin(to)) {
    next();
  } else {
    next({ name: 'Login', query: { redirect: to.fullPath } });
  }
});


export default router
